import { createContext, useContext, useEffect, useState } from "react";

const AppContext = createContext();

export function AppWrapper({ children }) {
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
    const [viewportWidth, setViewportWidth] = useState(undefined);
    const [breakpoint, setBreakpoint] = useState(768);
    const [activeIdx, setActiveIdx] = useState(null);

    // quiz related
    const [quizAnswers, setQuizAnswers] = useState();
    const [showResults, setShowResults] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuIsOpen(!mobileMenuIsOpen);
    };

    const updateBreakpoint = (num) => {
      setBreakpoint(num);
    };

    const handleWindowResize = () => {
        setViewportWidth(window.innerWidth);
    };

    

    let sharedState = {
      breakpoint,
      toggleMobileMenu,
      viewportWidth,
      activeIdx,
      setActiveIdx,
      quizAnswers,
      setQuizAnswers,
      showResults,
      setShowResults,
      mobileMenuIsOpen,
      updateBreakpoint,
      setMobileMenuIsOpen,
    };

    useEffect(() => {
        if (viewportWidth === undefined) {
            setViewportWidth(window.innerWidth);
        }

        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, [viewportWidth]);

    return (
        <AppContext.Provider value={sharedState}>{children}</AppContext.Provider>
    );
}

export function useAppContext() {
    return useContext(AppContext);
}
